import type { SessionBootstrapResponse } from '../user/session-bootstrap';

let bootstrapPromise: Promise<SessionBootstrapResponse> | null = null;

/**
 * Memoized per page load: the bootstrap identity is fetched once and shared by every
 * consumer (store hydration, session refresher, consent). Reset on failure so the
 * next caller retries instead of caching the error forever.
 */
export const getSessionBootstrap = (): Promise<SessionBootstrapResponse> => {
  bootstrapPromise ??= fetch('/api/session/bootstrap', { credentials: 'same-origin' }).then(
    (response) => {
      if (!response.ok) {
        bootstrapPromise = null;
        throw new Error(`session bootstrap failed: ${response.status}`);
      }
      return response.json() as Promise<SessionBootstrapResponse>;
    },
    (error) => {
      bootstrapPromise = null;
      throw error;
    },
  );
  return bootstrapPromise;
};

export const __resetSessionBootstrapForTesting = () => {
  bootstrapPromise = null;
};
